import {
  GraphQLObjectType,
  GraphQLID,
  GraphQLNonNull,
  GraphQLList,
  GraphQLString,
  GraphQLInt
} from 'graphql'
import { ATOAttackTypeType, ATOAttackType } from './ato-attack-type'
import { TimeWindowType, TimeWindow } from './time-window'

export interface ATOAttack {
  readonly id: string
  readonly type: ATOAttackType
  readonly window: TimeWindow
  readonly applicationID: string
  readonly principals: string[]
  readonly attempts: number
  readonly ipAddresses: string[]
}

export const ATOAttackGqlType = new GraphQLObjectType({
  name: 'ATOAttack',
  fields: () => ({
    id: {
      description: 'The unique ID for this ATO attack',
      type: new GraphQLNonNull(GraphQLID)
    },
    type: {
      description: 'The type of ATO attack',
      type: new GraphQLNonNull(ATOAttackTypeType)
    },
    window: {
      description:
        'The window that defines the start and end date of the attack',
      type: new GraphQLNonNull(TimeWindowType)
    },
    applicationID: {
      description: 'The ID of the application that was attacked',
      type: new GraphQLNonNull(GraphQLID)
    },
    principals: {
      description: 'The accounts related to the takeover attack',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    },
    attempts: {
      description:
        'The number of failed login attempts associated to this attack',
      type: new GraphQLNonNull(GraphQLInt)
    },
    ipAddresses: {
      description: 'The IP addresses related to the takeover attack',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    }
  })
})
